const MunicipalityService = {
    getAvailableMunicipalitiesByZoneId: (zoneId, availableZones, availableMunicipalities) => {
        const targetZone = availableZones.find((zone) => zone.id === zoneId);
        let result = [];
        if (targetZone && availableMunicipalities.length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (const zone of targetZone.zone_members) {
                const targetMunicipalities = availableMunicipalities.filter((municipality) => zone.zoneable_id === municipality.state_id);
                result = [...result, ...targetMunicipalities];
            }
        }
        return result;
        // return availableMunicipalities;
    },
    isMunicipalitySelectorModalRequired: (currentMunicipality, selectedZoneMunicipalities) => {
        if (selectedZoneMunicipalities.length > 0 && (!currentMunicipality || !selectedZoneMunicipalities.find((municipality) => municipality.id === currentMunicipality))) {
            return true;
        }
        return false;
    },
    getMunicipalityInfoFromOrderResponse: (response) => {
        const { data: { relationships: { municipality: { data: municipalityData } } }, included } = response;
        let municipalityInfo;
        if (municipalityData && municipalityData.id) {
            municipalityInfo = included.find((info) => info.id === municipalityData.id);
        }
        return municipalityInfo;
    },
};

export default MunicipalityService;



/** WEBPACK FOOTER **
 ** ./src/services/municipality-service.js
 **/